// Locale resolution shared by every formatter in this folder.
/**
 * Number-formatting locale per UI language (i18next language codes).
 * Values must be valid BCP-47 tags — `Intl.NumberFormat` throws on junk, and
 * `i18n.language` can hold arbitrary localStorage content, so lookups always
 * go through this map rather than passing the language straight to Intl.
 */
export const LANGUAGE_LOCALES = {
    en: 'en-US', // 1,234.56
    fr: 'fr-FR', // 1 234,56
    nl: 'nl-NL', // 1.234,56
};
/**
 * Get the number-formatting locale for a viewer's UI language.
 *
 * The locale follows the VIEWER (UI language), not the currency, so a
 * page mixing EUR and USD amounts renders one consistent number convention
 * (e.g. "€7,886.24" and "$140.40" in an English UI). Regional language codes
 * ("nl-BE") map by primary subtag; unknown languages and a missing language
 * (the pre-init window, where `i18n.language` is undefined) fall back to
 * 'en-US'.
 *
 * @param language - Viewer/document language code
 * @returns Locale string for proper number formatting
 */
export function localeForLanguage(language) {
    const primary = (language ?? 'en').slice(0, 2).toLowerCase();
    return LANGUAGE_LOCALES[primary] ?? 'en-US';
}
//# sourceMappingURL=locale.js.map